import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

import { viewPortBreakpoints } from "ui/styles/viewport";

const SidePanelAnchor = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: calc(100% - var(--boost-ui-sidebar-width, 0px));
  transition: 200ms ease-out;
  transform: ${(props) => (props.$isOpen ? "none" : "translateX(100%)")};
  box-shadow: ${(props) => (props.$isOpen ? "-4px 0 16px rgba(19, 20, 21, 0.2)" : "none")};
  z-index: 500;
  height: 100%;
  overscroll-behavior: contain;
  background: ${(p) => p.theme.bgHighestContrast};

  @media (min-width: ${viewPortBreakpoints.lg}) {
    width: calc(50% - var(--boost-ui-sidebar-width, 0px) / 2);
  }
`;

export const SidePanelPortal = (props: { children: React.ReactNode; isOpen: boolean }) => {
  const { children, isOpen } = props;

  let root = document.querySelector("body > #side-panel-portal");
  if (!root) {
    root = Object.assign(document.createElement("div"), { id: "side-panel-portal" });
    document.body.appendChild(root);
  }

  return ReactDOM.createPortal(
    <SidePanelAnchor $isOpen={isOpen}>{children}</SidePanelAnchor>,
    root,
  );
};
